import { Grid as MaterialGrid } from "@material-ui/core";
import styled, { css } from "styled-components";
import { device, size } from "../styles/media";

export const FullSize = css`
  width: 100%;
  height: 100%;
`;

export const Cover = css`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const ellipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CenteredFlex = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Flex = styled.div<{
  center?: boolean;
  justify?:
    | "center"
    | "end"
    | "flex-end"
    | "flex-start"
    | "start"
    | "space-around"
    | "space-between"
    | "space-evenly"
    | "stretch";
  fullWidth?: boolean;
}>`
  display: flex;
  align-items: center;

  ${(props) => (props.fullWidth ? "width: 100%;" : "")}
  ${(props) => (props.center ? "justify-content: center;" : "")}
  ${(props) => (props.justify ? "justify-content: " + props.justify : "")}
`;

export const columnFlex = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const Grid = styled.div<{
  ["col-sm"]?: number;
  ["col-lg"]?: number;
  ["col-xs"]?: number;
  alignItems?:
    | "auto"
    | "normal"
    | "start"
    | "end"
    | "center"
    | "stretch"
    | "baseline"
    | "first baseline"
    | "last baseline";
}>`
  display: grid;
  gap: 1em;
  grid-template-columns: repeat(${(props) => props["col-xs"] || 2}, 1fr);
  grid-template-rows: 1fr;
  grid-auto-flow: dense; /* or 'row', 'row dense', 'column dense' */
  grid-auto-rows: 1fr;

  ${(props) => (props?.alignItems ? `align-items: ${props.alignItems};` : "")}

  @media ${device.tablet} {
    grid-template-columns: repeat(
      ${(props) => props["col-sm"] || props["col-xs"] || 2},
      1fr
    );
  }

  @media ${device.laptopL} {
    grid-template-columns: repeat(
      ${(props) => props["col-lg"] || props["col-sm"] || props["col-xs"] || 3},
      1fr
    );
  }
`;

export const hiddenMobile = css`
  @media (max-width: ${size.laptop - 1}px) {
    display: none;
  }
`;

export const hiddenDesktop = css`
  @media ${device.laptop} {
    display: none;
  }
`;

export const WrapGridCell = styled(MaterialGrid).attrs({ item: true })`
  overflow-wrap: break-word;
`;

export const GridItem = styled(MaterialGrid).attrs({
  item: true,
})<{
  center?: boolean;
  top?: boolean;
  column?: boolean;
}>`
  display: flex;
  align-items: ${(props) => (props.top ? "flex-start" : "center")};
  ${(props) => (props.center ? "justify-content: center;" : "")}
  ${(props) => (props.column ? "flex-direction: column;" : "")}
`;
